module.exports = __webpack_public_path__ + "static/img/about-img1.79fb3a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/about-img1.png
// module id = BAqv
// module chunks = 0